import mondaySdk from 'monday-sdk-js';

import { createMondayClient } from '@gorilla/common/src/lib/monday-api/common';
import { createMondaySeamlessRequester } from '@gorilla/common/src/lib/monday-api/seamless';

export const monday = mondaySdk();

export async function getSessionToken() {
  return ((await monday.get('sessionToken')) as any).data;
}

export async function getContext() {
  return ((await monday.get('context')) as any).data;
}

export const mondayClient = createMondayClient(createMondaySeamlessRequester());
